module.exports = __webpack_public_path__ + "img/fudanLOGO.a6a485f9.png";